import { Col, Form, InputNumber } from 'antd'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'

const floatFormatter = (value: string | number | undefined) => {
  if (!value) return ''
  // Format value as float with comma separators
  return Number(value).toLocaleString()
}

const floatParser = (value: string | undefined) => {
  if (!value) return ''
  // Remove non-numeric characters (e.g., '$' and ',')
  return value.replace(/\$\s?|(,*)/g, '')
}

export default function FloatFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }
  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`float-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <InputNumber
          size='small'
          parser={floatParser}
          formatter={floatFormatter}
          stringMode
        />
      </Form.Item>
    </Col>
  )
}
